module.exports = __webpack_public_path__ + "static/media/grad_line.2d6b2e91.svg";